export const ProjectStates = Object.freeze({
  PLANNED: "planned",
  DEVELOPMENT: "development",
  PRODUCTION: "production",
  ARCHIVED: "archived",
  IMPORTING: "importing",
  ERROR: "error",
});
